module.exports = __webpack_public_path__ + "img/mermaid.57b50cce.gif";